import { ReduxStore } from 'store/types';

function getAllEmptyMsg(state: ReduxStore): string {
  return state.intervention.getAll.config.emptyMsg;
}

export default getAllEmptyMsg;
